import {LOCALE_LIST} from './constant';
import ko from './ko';

export type TranslateType = typeof ko;
export type TranslateKey = keyof TranslateType;
export type LocaleType = (typeof LOCALE_LIST)[number];
